module.exports = __webpack_public_path__ + "static/media/day-cloudy-icon.f9e225c1.svg";